<template>
  <button type="button" class="btn-main-processing">
    <i class="fa-solid fa-sync fa-spin mt-1" />
    <span class="space-icon" />{{ label }}
  </button>
</template>

<script>
export default {
  name: "MainButtonProcessing",
  props: ["label"],
};
</script>